import type { ReactNode } from "react";
import { createContext, useContext } from "react";

const MainScrollContext = createContext<HTMLElement | null>(null);

export const MainScrollProvider = ({ element, children }: { element: HTMLElement | null; children: ReactNode }) => (
  <MainScrollContext.Provider value={element}>{children}</MainScrollContext.Provider>
);

export const useMainScrollElement = () => useContext(MainScrollContext);
